[
  {
    "name": "Denmark",
    "iso_code": "DK",
    "has_multiple_zones": true,
    "bidding_zones": [
      { "id": "DK1", "name": "Denmark 1 (West)", "eic": "10YDK-1--------W" },
      { "id": "DK2", "name": "Denmark 2 (East)", "eic": "10YDK-2--------M" }
    ]
  },
  {
    "name": "Sweden",
    "iso_code": "SE",
    "has_multiple_zones": true,
    "bidding_zones": [
      { "id": "SE1", "name": "Sweden 1 (Luleå)", "eic": "10Y1001A1001A44P" },
      { "id": "SE2", "name": "Sweden 2 (Sundsvall)", "eic": "10Y1001A1001A45N" },
      { "id": "SE3", "name": "Sweden 3 (Stockholm)", "eic": "10Y1001A1001A46L" },
      { "id": "SE4", "name": "Sweden 4 (Malmö)", "eic": "10Y1001A1001A47J" }
    ]
  },
  {
    "name": "Norway",
    "iso_code": "NO",
    "has_multiple_zones": true,
    "bidding_zones": [
      { "id": "NO1", "name": "Norway 1 (Oslo)", "eic": "10YNO-1--------2" },
      { "id": "NO2", "name": "Norway 2 (Kristiansand)", "eic": "10YNO-2--------T" },
      { "id": "NO3", "name": "Norway 3 (Molde/Trondheim)", "eic": "10YNO-3--------J" },
      { "id": "NO4", "name": "Norway 4 (Tromsø)", "eic": "10YNO-4--------9" },
      { "id": "NO5", "name": "Norway 5 (Bergen)", "eic": "10YNO-5--------0" }
    ]
  },
  {
    "name": "Italy",
    "iso_code": "IT",
    "has_multiple_zones": true,
    "bidding_zones": [
      { "id": "IT-North", "name": "Northern Italy", "eic": "10Y1001A1001A737" },
      { "id": "IT-CNor", "name": "Central-Northern Italy", "eic": "10Y1001A1001A70D" },
      { "id": "IT-CSud", "name": "Central-Southern Italy", "eic": "10Y1001A1001A71M" },
      { "id": "IT-South", "name": "Southern Italy", "eic": "10Y1001A1001A788" },
      { "id": "IT-Calabria", "name": "Calabria", "eic": "10Y1001C--00096J" },
      { "id": "IT-Sicily", "name": "Sicily", "eic": "10Y1001A1001A75E" },
      { "id": "IT-Sardinia", "name": "Sardinia", "eic": "10Y1001A1001A74G" }
    ]
  },
  {
    "name": "Germany / Luxembourg",
    "iso_code": "DE",
    "has_multiple_zones": false,
    "comment": "Combined market zone",
    "bidding_zones": [
      { "id": "DE-LU", "name": "Germany / Luxembourg", "eic": "10YCBA-GERMANY--8" }
    ]
  },
  {
    "name": "Austria",
    "iso_code": "AT",
    "has_multiple_zones": false,
    "bidding_zones": [
      { "id": "AT", "name": "Austria", "eic": "10YAT-APG------L" }
    ]
  },
  {
    "name": "Belgium",
    "iso_code": "BE",
    "has_multiple_zones": false,
    "bidding_zones": [
      { "id": "BE", "name": "Belgium", "eic": "10YBE----------2" }
    ]
  },
  {
    "name": "Netherlands",
    "iso_code": "NL",
    "has_multiple_zones": false,
    "bidding_zones": [
      { "id": "NL", "name": "Netherlands", "eic": "10YNL----------L" }
    ]
  },
  {
    "name": "France",
    "iso_code": "FR",
    "has_multiple_zones": false,
    "bidding_zones": [
      { "id": "FR", "name": "France", "eic": "10YFR-RTE------C" }
    ]
  },
  {
    "name": "Spain",
    "iso_code": "ES",
    "has_multiple_zones": false,
    "bidding_zones": [
      { "id": "ES", "name": "Spain", "eic": "10YES-REE------0" }
    ]
  },
  {
    "name": "Portugal",
    "iso_code": "PT",
    "has_multiple_zones": false,
    "bidding_zones": [
      { "id": "PT", "name": "Portugal", "eic": "10YPT-REN------W" }
    ]
  },
  {
    "name": "Finland",
    "iso_code": "FI",
    "has_multiple_zones": false,
    "bidding_zones": [
      { "id": "FI", "name": "Finland", "eic": "10YFI-1--------U" }
    ]
  },
  {
    "name": "Poland",
    "iso_code": "PL",
    "has_multiple_zones": false,
    "bidding_zones": [
      { "id": "PL", "name": "Poland", "eic": "10YPL-AREA-----S" }
    ]
  },
  {
    "name": "Czech Republic",
    "iso_code": "CZ",
    "has_multiple_zones": false,
    "bidding_zones": [
      { "id": "CZ", "name": "Czech Republic", "eic": "10YCZ-CEPS-----N" }
    ]
  },
  {
    "name": "Hungary",
    "iso_code": "HU",
    "has_multiple_zones": false,
    "bidding_zones": [
      { "id": "HU", "name": "Hungary", "eic": "10YHU-MAVIR----U" }
    ]
  },
  {
    "name": "Romania",
    "iso_code": "RO",
    "has_multiple_zones": false,
    "bidding_zones": [
      { "id": "RO", "name": "Romania", "eic": "10YRO-TEL------P" }
    ]
  },
  {
    "name": "Bulgaria",
    "iso_code": "BG",
    "has_multiple_zones": false,
    "bidding_zones": [
      { "id": "BG", "name": "Bulgaria", "eic": "10YCA-BULGARIA-R" }
    ]
  },
  {
    "name": "Greece",
    "iso_code": "GR",
    "has_multiple_zones": false,
    "bidding_zones": [
      { "id": "GR", "name": "Greece", "eic": "10YDOM-REGION-1V" }
    ]
  },
  {
    "name": "Estonia",
    "iso_code": "EE",
    "has_multiple_zones": false,
    "bidding_zones": [
      { "id": "EE", "name": "Estonia", "eic": "10Y1001A1001A39I" }
    ]
  },
  {
    "name": "Latvia",
    "iso_code": "LV",
    "has_multiple_zones": false,
    "bidding_zones": [
      { "id": "LV", "name": "Latvia", "eic": "10YLV-1001A00074" }
    ]
  },
  {
    "name": "Lithuania",
    "iso_code": "LT",
    "has_multiple_zones": false,
    "bidding_zones": [
      { "id": "LT", "name": "Lithuania", "eic": "10YLT-1001A0008Q" }
    ]
  },
  {
    "name": "Switzerland",
    "iso_code": "CH",
    "has_multiple_zones": false,
    "bidding_zones": [
      { "id": "CH", "name": "Switzerland", "eic": "10YCH-SWISSGRIDZ" }
    ]
  },
  {
    "name": "United Kingdom",
    "iso_code": "GB",
    "has_multiple_zones": false,
    "bidding_zones": [
      { "id": "GB", "name": "Great Britain", "eic": "10YGB----------A" }
    ]
  },
  {
    "name": "Ireland",
    "iso_code": "IE",
    "has_multiple_zones": false,
    "comment": "Single Electricity Market with Northern Ireland",
    "bidding_zones": [
      { "id": "SEM", "name": "Ireland & NI (SEM)", "eic": "10YDOM-1001A079A" }
    ]
  }
]

